import { motion } from 'framer-motion'
import { useInView } from 'react-intersection-observer'
import { Mail, MessageSquare, Github, Linkedin, Twitter } from 'lucide-react'

const Contact = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  })

  const contactMethods = [
    {
      icon: Mail,
      title: "Email",
      value: "claireluoyx@gmail.com",
      href: "mailto: claireluo.yx@gmail.com",
    },
    {
      icon: Mail,
      title: ".edu email",
      value: "claire_luo1@brown.edu",
      href: "mailto: claire_luo1@brown.edu",
    },
    {
      icon: MessageSquare,
      title: "LinkedIn",
      value: "linkedin.com/in/claireyluo",
      href: "https://linkedin.com/in/claireyluo"
    },
    {
      icon: Github,
      title: "GitHub",
      value: "github.com/claireyluo",
      href: "https://github.com/claireyluo",
      color: "from-gray-700 to-gray-800"
    },
  ]

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
        delayChildren: 0.1
      }
    }
  }

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.6,
        ease: "easeOut"
      }
    }
  }

  return (
    <div className="container-max" ref={ref}>
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate={inView ? "visible" : "hidden"}
        className="space-y-8 relative"
      >
        {/* Koi Animation */}
        <div className="absolute right-8 top-1/2 transform -translate-y-1/2 w-96 h-96">
          <img
            src="/koi.gif"
            alt="Swimming koi"
            className="w-full h-full object-contain animate-orbit"
            style={{
              animation: 'orbit 40s linear infinite',
              filter: 'drop-shadow(0 4px 12px rgba(56, 106, 139, 0.4))'
            }}
          />
        </div>

        {/* Header */}
        <motion.div
          variants={itemVariants}
          className="space-y-4"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-primary"
            style={{ marginBottom: '1rem' }}>
            contact
          </h2>
          <p className="text-xl text-muted font-mono max-w-2xl">
            always open to new opportunities & collaborations!<br />
            currently seeking fall 2026 opportunities~
          </p>
        </motion.div>

        {/* Contact Methods */}
        <motion.div variants={itemVariants} className="max-w-xs">
          <div className="space-y-3">
            {contactMethods.map((method, index) => (
              <motion.a
                key={method.title}
                href={method.href}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 p-1"
              >
                <div className="p-3 rounded-lg bg-white/20 text-primary">
                  <method.icon size={24} />
                </div>
                <div className="flex-1">
                  <h4 className="font-semibold text-primary group-hover:text-primary-400 transition-colors">
                    {method.title}
                  </h4>
                  <p className="text-primary">{method.value}</p>
                </div>
              </motion.a>
            ))}
          </div>

          
        </motion.div>

        {/* Spacer for guaranteed separation above footer */}
        <div className="h-12 md:h-20"></div>

        {/* Footer */}
        <motion.div
          variants={itemVariants}
          className="text-center space-y-2 pt-2 border-t border-white/10 pb-16 mb-0"
        >
          <p className="text-primary">
            thanks for visiting!
          </p>
          <p className="text-sm text-gray-500">
            © 2026 Claire Luo. built with lots of 🧋
          </p>
        </motion.div>
      </motion.div>
    </div>
  )
}

export default Contact 